import ReactPlayer from 'react-player'

import './index.css'

const LivePlayer = props => {
  const {liveVideo} = props

  return (
    <div id="video-container">
      <h1 className="live-head">WEDDING VIDEO</h1>

      <hr className="hr-line-3" />
      <div className="responsive-container">
        <ReactPlayer
          controls
          url={liveVideo}
          className="video"
          width="100%"
          height="100%"
        />
        <h1 className="heading-5">Sai Weds Sruthi</h1>
      </div>
    </div>
  )
}

export default LivePlayer
